const inMemoryStorage = new Map<string, string>();

export function getItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return inMemoryStorage.get(key) ?? null;
  }
}

export function setItem(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    inMemoryStorage.set(key, value);
  }
}

export function removeItem(key: string) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    inMemoryStorage.delete(key);
  }
}
